import { useLocation, useParams } from 'react-router-dom';
import { HerdMoveDialog } from 'app/agriculture/routes/Herds/HerdMove/components/HerdMoveDialog';
import { NotFound } from 'app/agriculture/routes/NotFound';

export function HerdMove() {
    const { id } = useParams();
    const location = useLocation();
    if (!isObjectContainingPaddockId(location.state)) return <NotFound />;
    const { paddockId } = location.state;
    if (id == null) return <NotFound />;

    return <HerdMoveDialog herdId={id} paddockId={paddockId} />;
}

function isObjectContainingPaddockId(x: unknown): x is { paddockId: string } {
    if (x == null || typeof x !== 'object' || !('paddockId' in x)) return false;
    return typeof x.paddockId === 'string';
}
